import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router';
import { Helmet } from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import Button from '../../components/Button/Button';
import { notification, Collapse } from 'antd';
//import { getSubjectContent, getSchools } from "../../services/learnService";
import Place from '../../assets/icons/Place';
import picture from '../../assets/images/instructor.svg';
import { learnSubject } from '../../dummyData';
import moment from 'moment';
import ReactPlayer from 'react-player/lazy';
import { convertTime } from '../../utils/utils';

import { getTopic } from '../../services/learnService';
import Spinner from '../../components/Spinner/Spinner';
import { baseURL } from '../../utils/axios';

const TakeCourse = () => {
  const { Panel } = Collapse;
  let query = new URLSearchParams(useLocation().search);
  let topicId = query.get('topic');
  const scrollRef = useRef(null);
  const executeScroll = () =>
    scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

  const ids = useParams();
  const navigate = useNavigate();

  let user = JSON.parse(localStorage.getItem('userData'));

  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(false);
  const [schools, setSchools] = useState([]);
  const [playLoading, setPlayLoading] = useState(false);
  const [selectdContent, setSelectedContent] = useState({});
  const [topics, setTopics] = useState({
    description: '',
    id: '',
    lessons: [],
    published: '',
    published_at: '',
    title: '',
  });

  let school = schools.filter((el) => JSON.stringify(el.id) === ids?.schoolId);

  const weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const d = new Date();
  let day = weekdays[d.getDay()];
  let hour = d.getHours();

  useEffect(() => {
    let token = localStorage.getItem('token');
    setLoading(true);
    const getContent = async () => {
      const res = await fetch(
        `${baseURL}/schools/${ids.schoolId}/courses/${ids.subjectId}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json; charset=utf-8',
          },
        }
      );
      const data = await res.json();

      if (res.status === 200) {
        setContent(data?.data?.course);
      } else {
        setContent(learnSubject);
      }

      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        navigate('/login');
      }
      setLoading(false);
    };
    setLoading(false);
    getContent();
  }, []);

  useEffect(() => {
    const getSingleTopic = async () => {
      setLoading(true);
      try {
        let token = localStorage.getItem('token');
        let { id } = JSON.parse(localStorage.getItem('userData'));
        let res = await getTopic(token, id, ids.subjectId, topicId);
        setTopics(res?.data?.topic);
        if (res?.data?.topic?.lessons[0].contents[0]?.type === 'video') {
          setPlayLoading(true);
        } else {
          setPlayLoading(false);
        }
        setSelectedContent(res?.data?.topic?.lessons[0].contents[0]);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    };

    getSingleTopic();
  }, []);

  useEffect(() => {
    let token = localStorage.getItem('token');

    const getAllSchools = async () => {
      const res = await fetch(`${baseURL}/schools`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSchools(data?.data?.schools);
      }

      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        navigate('/login');
      }
    };
    getAllSchools();
  }, []);

  const setCurrentContent = (item) => {
    if (item.type === 'video') {
      setPlayLoading(true);
    } else {
      setPlayLoading(false);
    }
    setSelectedContent(item);
  };

  return (
    <>
      <Helmet>
        <title>PL by Edves | Learn</title>
      </Helmet>
      <DashboardHeader />
      <div className='takecourse'>
        <div className='takecourse__breadcrumbs'>
          <span>
            <svg
              width='18'
              height='12'
              viewBox='0 0 18 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z'
                fill='#161410'
              />
            </svg>
          </span>
          <p>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/dashboard')}
            >
              {' '}
              Home
            </span>{' '}
            | {school[0]?.name} | {content?.title} |{' '}
          </p>
          <span>
            <p style={{ color: '#161410' }}>Learn {content?.title}</p>
          </span>
        </div>
        <div className='takecourse__body'>
          <div className='takecourse__body__course-details'>
            {loading ? (
              <div className='takecourse__body__course-details__section'>
                <Spinner />
              </div>
            ) : (
              <div className='takecourse__body__course-details__section'>
                {playLoading && <Spinner />}
                {selectdContent?.type === 'image' ? (
                  <img src={selectdContent.location} alt='' />
                ) : selectdContent?.type === 'video' ? (
                  <ReactPlayer
                    url={selectdContent.location}
                    controls
                    width='100%'
                    height='100%'
                    onReady={(prev) => {
                      setPlayLoading(!prev?.player?.isReady);
                    }}
                  />
                ) : selectdContent?.type === 'text' ? (
                  <div className='render-text'>
                    {selectdContent.description}
                  </div>
                ) : selectdContent?.type === 'doc' ? (
                  <iframe
                    width='100%'
                    height={'100%'}
                    title={`title${Math.random()}`}
                    src={selectdContent.location}
                  ></iframe>
                ) : selectdContent?.type === 'audio' ? (
                  <div
                    className='audio-placeholder'
                    style={{ backgroundImage: `url(${school[0]?.logo})` }}
                  >
                    <audio controls>
                      <source src={selectdContent.location} type='audio/ogg' />
                      <source src={selectdContent.location} type='audio/mpeg' />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            )}
            <div className='takecourse__body__course-details__action'>
              <div className='takecourse__body__course-details__action__left'>
                <div className='takecourse__body__course-details__action__left__icon'>
                  <svg
                    width='12'
                    height='8'
                    viewBox='0 0 12 8'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M8 1.33333V6.66667H1.33333V1.33333H8ZM8.66667 0H0.666667C0.3 0 0 0.3 0 0.666667V7.33333C0 7.7 0.3 8 0.666667 8H8.66667C9.03333 8 9.33333 7.7 9.33333 7.33333V5L12 7.66667V0.333333L9.33333 3V0.666667C9.33333 0.3 9.03333 0 8.66667 0Z'
                      fill='#5A5955'
                    />
                  </svg>
                </div>
                <div className='takecourse__body__course-details__action__left__text'>
                  <h3>Need help about anything?</h3>
                  <p>Book a one- on- one session with the tutor</p>
                </div>
              </div>
              <div className='takecourse__body__course-details__action__right'>
                <Button
                  text='See live classes'
                  className='primary-btn'
                  onClick={() => {
                    executeScroll();
                  }}
                />
              </div>
            </div>

            <div className='takecourse__body__about'>
              <h3>About this subject</h3>
              <p>{topics?.description}</p>
            </div>

            <div className='takecourse__body__about'>
              <h3>What you’ll learn</h3>
              <div className='learn-about__what-you-will-learn'>
                {content?.learning_outcomes?.map((el) => (
                  <div
                    className='learn-about__flex-item'
                    key={Math.random(1000)}
                  >
                    <div className='learn-about__flex-item__circle'>
                      <svg
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M6.0001 10.7799L3.2201 7.9999L2.27344 8.9399L6.0001 12.6666L14.0001 4.66656L13.0601 3.72656L6.0001 10.7799Z'
                          fill='#161410'
                        />
                      </svg>
                    </div>
                    <p>{el.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className='takecourse__body__about'>
              <h3 ref={scrollRef}>Live class schedule (Group class)</h3>
              <div className='learn-about__schedule'>
                <div className='learn-about__schedule__icon'>
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clipPath='url(#clip0_4556_18787)'>
                      <path
                        d='M10 5.33333V10.6667H3.33333V5.33333H10ZM10.6667 4H2.66667C2.3 4 2 4.3 2 4.66667V11.3333C2 11.7 2.3 12 2.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9L14 11.6667V4.33333L11.3333 7V4.66667C11.3333 4.3 11.0333 4 10.6667 4Z'
                        fill='#5A5955'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_4556_18787'>
                        <rect width='16' height='16' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div>
                  {content?.live_classes ? (
                    content?.live_classes?.map((el) => (
                      <div className='learn-about__schedule__texts'>
                        <h4>
                          {moment(el?.start_date).format('dddd MMMM Do, YYYY')}{' '}
                          - {moment(el?.end_date).format('dddd MMMM Do, YYYY')}
                        </h4>
                        {el?.schedules?.map((item) => (
                          <>
                            <div
                              className='learn-about__schedule__texts__item'
                              style={{ marginBottom: '5px' }}
                            >
                              <p>{item?.day}</p>
                              <svg
                                width='4'
                                height='4'
                                viewBox='0 0 4 4'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle cx='2' cy='2' r='2' fill='#D5D4D4' />
                              </svg>
                              <p>
                                {convertTime(item?.start_time)} -{' '}
                                {convertTime(item?.end_time)}
                              </p>
                            </div>

                            <Button
                              className={'primary-btn'}
                              text={'Join Class'}
                              disabled={
                                day.toLowerCase() !==
                                  item?.day?.toLowerCase() ||
                                hour < Number(item?.start_time?.split(':')[0])
                              }
                              onClick={() => {
                                window.open(el?.meeting_url, '_blank');
                              }}
                            />
                          </>
                        ))}
                      </div>
                    ))
                  ) : (
                    <div className='learn-about__schedule__texts'>
                      <p>No live class available for this topic</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='takecourse__body__help'>
              <h3>Need extra help?</h3>
              <div className='takecourse__body__help__flex'>
                <div className='takecourse__body__help__flex__logo'>
                  <img
                    src={school[0]?.logo || picture}
                    alt={school[0]?.school_name}
                  />
                </div>
                <div className='takecourse__body__help__flex__tutor'>
                  <h4>{school[0]?.name || ''} </h4>
                  <div>
                    <Place />
                    {school[0]?.school_state ? (
                      <p style={{ margin: '0' }}>
                        {`${school[0]?.state}, ${school[0]?.country}`}
                      </p>
                    ) : (
                      <p>Lagos,Nigeria</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='takecourse__body__subject-content'>
            <h3>Subject Content</h3>

            <Collapse defaultActiveKey={['1']} expandIconPosition={'right'}>
              {loading ? (
                <Spinner />
              ) : (
                topics.lessons.map((el, id) => (
                  <Panel
                    className='takecourse__body__subject-content__collapse-header'
                    header={
                      <div>
                        <div className='takecourse__body__subject-content__heading'>
                          {' '}
                          <span
                            style={{ marginRight: '10px', color: '#5A5955' }}
                          >
                            <h4> {`${el.sn}.0`}</h4>
                          </span>
                          <span>
                            <h4> {el.title}</h4>
                          </span>
                        </div>
                        <div className='takecourse__body__subject-content__subheading'>
                          <p>Estimated duration | 15 mins</p>
                        </div>
                      </div>
                    }
                  >
                    {el?.contents?.map((item, idx) => (
                      <div
                        className={
                          selectdContent.id === item.id
                            ? 'active-sub-wrapper'
                            : 'sub-wrapper'
                        }
                      >
                        <div className='content__topics__sub'>
                          <div
                            style={{
                              display: 'flex',
                              gap: '17px',
                            }}
                          >
                            <div style={{ marginTop: '3px' }}>
                              <svg
                                width='14'
                                height='12'
                                viewBox='0 0 14 12'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M11.7768 0H1.79339C1.00898 0 0.367188 0.6 0.367188 1.33333V10.6667C0.367188 11.4 1.00898 12 1.79339 12H11.7768C12.5612 12 13.203 11.4 13.203 10.6667V1.33333C13.203 0.6 12.5612 0 11.7768 0ZM11.7768 10.6667H1.79339V1.33333H11.7768V10.6667ZM11.0566 4L10.0511 3.05333L5.35176 7.44667L3.51196 5.73333L2.49936 6.67333L5.35176 9.33333L11.0566 4Z'
                                  fill='#FEA82F'
                                />
                              </svg>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                gap: '17px',
                                flexDirection: 'column',
                                gap: '8px',
                              }}
                              onClick={() => {
                                setCurrentContent(item);
                              }}
                            >
                              <p
                                style={{
                                  fontWeight: 700,
                                  marginBottom: '10px',
                                }}
                              >
                                {`${el.sn}.${idx + 1}`}{' '}
                                <span style={{ color: '#161410' }}>
                                  {item.title}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontWeight: 300,
                                  fontSize: '12px !important',
                                }}
                              >
                                {item.type === 'video' ? (
                                  <svg
                                    width='14'
                                    height='14'
                                    viewBox='0 0 14 14'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M5.66634 9.99992L9.66634 6.99992L5.66634 3.99992V9.99992ZM6.99967 0.333252C3.31967 0.333252 0.333008 3.31992 0.333008 6.99992C0.333008 10.6799 3.31967 13.6666 6.99967 13.6666C10.6797 13.6666 13.6663 10.6799 13.6663 6.99992C13.6663 3.31992 10.6797 0.333252 6.99967 0.333252ZM6.99967 12.3333C4.05967 12.3333 1.66634 9.93992 1.66634 6.99992C1.66634 4.05992 4.05967 1.66659 6.99967 1.66659C9.93967 1.66659 12.333 4.05992 12.333 6.99992C12.333 9.93992 9.93967 12.3333 6.99967 12.3333Z'
                                      fill='#161410'
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width='12'
                                    height='12'
                                    viewBox='0 0 12 12'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M7.44667 1.33333L10.6667 4.55333V10.6667H1.33333V1.33333H7.44667ZM7.44667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V4.55333C12 4.2 11.86 3.86 11.6067 3.61333L8.38667 0.393333C8.14 0.14 7.8 0 7.44667 0ZM2.66667 8H9.33333V9.33333H2.66667V8ZM2.66667 5.33333H9.33333V6.66667H2.66667V5.33333ZM2.66667 2.66667H7.33333V4H2.66667V2.66667Z'
                                      fill='#161410'
                                    />
                                  </svg>
                                )}{' '}
                                {item.type}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Panel>
                ))
                //
              )}
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default TakeCourse;
